import { Modal } from 'antd';
import type { ModalProps } from 'antd';

export const StyledModal = ({ okButtonProps, cancelButtonProps, ...props }: ModalProps) => {
	return (
		<Modal
			centered
			className="styled-modal"
			okButtonProps={{
				className: 'styled-btn styled-btn-color-brand',
				...okButtonProps,
			}}
			cancelButtonProps={{
				className: 'styled-btn styled-btn-color-black',
				...cancelButtonProps,
			}}
			{...props}
			data-testid="styled-modal"
		/>
	);
};
